import React from 'react';
import { func, string, bool } from 'prop-types';
import PageSelector from './PageSelector';

import CSS from './styles.scss';

const MenuViews = props => {
  return (
    <section className={ CSS['container'] }>
      <div className={ CSS['filler'] }></div>
        <nav aria-label={'E-book'} className={ CSS['nav-wrapper'] }>
          <ul role="tablist" className={ CSS['list'] }>
            <li role="tab" aria-selected={props.activeMenu === 'E-book'} className={ props.ebookListItem } onClick={ props.toggle } onKeyDown={ props.toggle } tabIndex="0">
              <div className={ props.ebookTabItem } data-test-id="ebook-tab">
                <span>E-book</span>
              </div>
            </li>
            <li role="tab" aria-selected={props.activeMenu === 'NOTEBOOK'} className={ props.notebookListItem } onClick={ props.toggle } onKeyDown={ props.toggle } tabIndex="0">
              <div className={ props.notebookTabItem } data-test-id="notebook-tab">
                <span>NOTEBOOK</span>
              </div>
            </li>
          </ul>
          { props.activeMenu === 'E-book'
            && props.showPageSelector &&
            <PageSelector />
          }
        </nav>
      <div className={ CSS['filler-hide-xs'] }></div>
    </section>
  );
};

MenuViews.propTypes = {
  ebookTabItem: string,
  notebookTabItem: string,
  notebookListItem: string,
  pageNumberListItem: string,
  toggle: func,
  activeMenu: string,
  showPageSelector: bool
};


export default MenuViews;
